import React, { createContext, useContext, useState } from 'react';

const RefreshContext = createContext<any>(null);

export const RefreshProvider = ({ children }: { children: React.ReactNode }) => {
    const [refreshKey, setRefreshKey] = useState(0);
    // //console.log("---log----------",refreshKey)
    return (
        <RefreshContext.Provider value={{ refreshKey, setRefreshKey }}>
            {children}
        </RefreshContext.Provider>
    );
};

export const useRefresh = () => useContext(RefreshContext);
